import React from 'react';
import PropTypes from 'prop-types';
import { humanReadableDate } from '../utils';
import '../assets/styles.css'

const ConversationEndedDivider = ({ content, chatEndedOn }) => {
    return (
        <div className='_kanis_divider'>
            {`${content || "Conversation ended"} ${humanReadableDate(new Date(chatEndedOn), { suffix: 'ago' })}`}
        </div>
    );
}

export default ConversationEndedDivider;

ConversationEndedDivider.propTypes = {
    content: PropTypes.string,
    chatEndedOn: PropTypes.string
};